import type { NextAuthOptions, Account, Session, User, Profile } from 'next-auth'
import AzureADProvider from 'next-auth/providers/azure-ad'
import type { JWT } from 'next-auth/jwt'

import { ENV_VAR } from '@/services'

interface ExtendedAccount extends Account {
  ext_expires_in?: number | null
  expires_at?: number
}

type JwtCallbackParams = {
  token: JWT
  account?: ExtendedAccount | null
  profile?: Profile | null
}

type SessionCallbackParams = {
  session: Session
  token: JWT
  user: User
}
const idToken_expires_in = 3600

const AuthOptions: NextAuthOptions = {
  providers: [
    AzureADProvider({
      clientId: ENV_VAR.AZURE_AD_CLIENT_ID as string,
      clientSecret: ENV_VAR.AZURE_AD_CLIENT_SECRET as string,
      tenantId: ENV_VAR.AZURE_AD_TENANT_ID,
      authorization: {
        params: {
          prompt: 'login',
          scope: 'openid profile email offline_access User.Read' //Aca hay una diferencia

          // scope: 'openid profile email'
        }
      }
    })
  ],
  secret: ENV_VAR.NEXTAUTH_SECRET,
  callbacks: {
    async jwt({ token, account, profile }: JwtCallbackParams): Promise<JWT> {
      const refreshMargin = 60

      //const refreshMargin = 3660

      console.debug('callbacks- jwt')

      console.debug('token', token)
      console.debug('account', account)
      console.debug('profile', profile)

      if (account) {
        console.debug('account->OK')
        token.accessToken = account.access_token
        token.idToken = account.id_token //Aca hay una diferencia
        token.refreshToken = account.refresh_token
        token.id = profile?.id || token.id
        token.email = profile?.email || token.email;
      }

      if (profile) {
        token.accessTokenExpires = Math.round(Date.now() / 1000) + idToken_expires_in
        console.debug('token.accessTokenExpires->', token.accessTokenExpires)
      }

      //* Consultamos strapi para encontrar el usuario y el Rol

      try {
        const res = await fetch(
          `${ENV_VAR.STRAPI_URL}/api/users?filters[email][$eq]=${token?.email}&populate=role`,
          { headers: { Authorization: `Bearer ${ENV_VAR.STRAPI_TOKEN}` } } 
        );
        const data = await res.json();

        // console.log('🧀 USER Information Strapi:',  `${ENV_VAR.STRAPI_URL}/api/users?filters[email][$eq]=${token?.email}&populate=role`)
        // console.log('🧀 USER Information Strapi:', `Bearer ${ENV_VAR.STRAPI_TOKEN}`)
        // console.log('🧀 Fucking Profile:', data )
        
  
        const user = data[0]; // Strapi devuelve array de users
        if (user) {
          token.role = user.role?.name || "authenticated";
          token.strapiId = user.id;
        } else {
          // Si no existe, podrías crearlo en Strapi aquí
          token.role = "guest";
        }
      } catch (err) {
        console.error("Error consultando Strapi:", err);
        token.role = "guest";
      }
  

      

      const accessTokenExpires = token.accessTokenExpires ?? 0 - refreshMargin
      const now_UnixTime = Math.round(Date.now() / 1000)

      console.debug('now_UnixTime->', now_UnixTime)
      console.debug('accessTokenExpires->', accessTokenExpires)

      if (now_UnixTime < accessTokenExpires) {
        console.debug('NO->refreshAccessToken')

        return token
      }

      try {
        const refreshedTokens = await refreshAccessToken(token)

        return {
          ...token,
          accessToken: refreshedTokens.accessToken,
          idToken: refreshedTokens.idToken, //otra diferencia
          refreshToken: refreshedTokens.refreshToken,
          accessTokenExpires: refreshedTokens.accessTokenExpires,
          id: profile?.id
        }
      } catch (error) {
        return {
          error: 'RefreshAccessTokenError'
        }
      }
    },
    async session({ session, token }: SessionCallbackParams): Promise<Session> {
      session.accessToken = token.accessToken
      session.idToken = token.idToken //otra diferencia
      session.user.id = token.id
      //* Agrego el rol del usuario a la session
      session.user.role = token.role;
      session.user.strapiId = token.strapiId;

      return session
    }
  },

  pages: {
    signIn: '/login',
    signOut: '/login',
    newUser: '/dashboard'
  }
}

async function refreshAccessToken(token: JWT) {
  try {
    console.debug('refreshAccessToken')
    const url = `https://login.microsoftonline.com/${ENV_VAR.AZURE_AD_TENANT_ID}/oauth2/v2.0/token`

    const params = new URLSearchParams({
      client_id: ENV_VAR.AZURE_AD_CLIENT_ID as string,
      client_secret: ENV_VAR.AZURE_AD_CLIENT_SECRET as string,
      grant_type: 'refresh_token',
      refresh_token: token.refreshToken as string,

      // scope: 'openid profile email offline_access User.Read Sites.Read.All Sites.ReadWrite.All'
      scope: 'openid profile email offline_access User.Read'

      // scope: 'openid profile email'
    })

    // console.log('Params: ', params.toString())

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: params.toString()
    })

    // console.log('Response : ', response)

    if (!response.ok) {
      throw new Error('Failed to refresh access token')
    }

    const refreshedTokens = await response.json()

    //console.log('Return: ', refreshedTokens)
    const accessTokenExpires = Math.round(Date.now() / 1000) + idToken_expires_in

    return {
      ...token,
      accessTokenExpires: accessTokenExpires,
      accessToken: refreshedTokens.access_token,
      idToken: refreshedTokens.id_token,
      refreshToken: refreshedTokens.refresh_token ?? token.refreshToken
    }
  } catch (error) {
    console.error('Error refreshing access token:', error)

    return {
      ...token,
      error: 'RefreshAccessTokenError'
    }
  }
}

export default AuthOptions
